import React from "react";
import {
    Modal,
    Form,
    Input,
    Button,
    Select,
    Checkbox,
    Spin,
    message,
    Icon,
} from "antd";
import { formItemLayout, tailFormItemLayout } from "$ACTIONS/constantsData";
import { get, post } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { realyNameReg } from "$ACTIONS/reg";
import ABankList from "$DATA/bank.static";
import Router from "next/router";
import SelectArddress from "../View/SelectArddress";

const { Item } = Form;
const { Option } = Select;
const _bankNumber = /^[0-9]{1,19}$/;
const _city = /^[a-zA-z\u4E00-\u9FA5]{1,20}$/;
const _branch = /^[a-zA-Z0-9\u4e00-\u9fa5]{2,20}$/;

class AddBankCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            BankList: [],
            isLoading: false,
            submitButtonDisabled: true,
            isSetDefault: false,
            setBankCard: {
                searchValue: "",
                showBankList: false,
                bankAlphabetic: "",
            },
            provincesIsValid: false,
        };
    }
    componentDidMount() {
        get(ApiPort.GETWithdrawalbank)
            .then((res) => {
                if (res && res.result) {
                    let filterDupBank = res.result.banks.filter(
                        (obj, pos, arr) => {
                            return (
                                arr
                                    .map((mapObj) => mapObj.name)
                                    .indexOf(obj.name) == pos
                            );
                        }
                    );
                    this.setState({
                        BankList: filterDupBank,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (!values) {
                    return alert(
                        "请检查个人信息是否完善，如仍无法提交请联系客服回馈错误！"
                    );
                }

                const { province, city, district } = values.province;
                const updatedProvince =
                    province.name + city.name + district.name;

                this.setState({ isLoading: true });

                post(ApiPort.POSTRememberBanks, {
                    accountHolderName: values.username,
                    accountNumber: values.cardnumber,
                    bankName: values.bankname,
                    branch: values.branch,
                    city: values.city,
                    province: updatedProvince,
                    type: "W",
                    isDefault: this.state.isSetDefault,
                })
                    .then((res) => {
                        this.setState({ isLoading: false });
                        console.log("response data", res);

                        if (res.isSuccess) {
                            Modal.info({
                                className: 'confirm-modal-of-public confirm-modal-of-public-tight hide-ant-modal-close-x-modal',
                                icon: <div />,
                                title: '银行卡新增成功',
                                centered: true,
                                okText: '我知道了',
                                content: '银行卡新增成功，请耐心等候系统审核',
                                onOk: () => {
                                  this.onclosed(true);
                                },
                            });
                            if (this.props.getMemberBanksList) {
                            this.props.getMemberBanksList();
                            }
                        }
                        //這裡加else沒有用 因為會是bad request 直接跑到 catch
                        else {
                            for (let i = 0; i < res.errors.length; i++) {
                                let temp = res.errors[i];
                                if (temp.errorCode == "PII00702") {
                                    Router.push("/cn/RestrictAccess");
                                    global.globalBlackListExit();
                                    break;
                                } else if (temp.errorCode == "VAL11056") {
                                    message.error("提款卡保存失败", 3);
                                    break;
                                }
                            }
                        }
                    })
                    .catch((error) => {
                        console.log("error", error);
                    });
            }
        });

        if (this.props.useAt==='WITHDRAWAL') {
            Pushgtagdata('Withdrawal_Account', 'Submit Account', 'Withdraw_Account_Manual_C_Account')
        } else {
        Pushgtagdata("Submit_addbankcar_bankacc");
        };
    };
    handleFormChange = () => {
        let status =
            Object.entries(this.props.form.getFieldsError()).every(
                (v) => v[1] === undefined
            ) &&
            Object.entries(this.props.form.getFieldsValue()).every(
                (v) => v[1] !== undefined
            ) &&
            this.props.form.getFieldValue("bankname") &&
            this.state.setBankCard.searchValue &&
            this.state.provincesIsValid;
        this.setState({ submitButtonDisabled: !status });
        console.log("getFieldValue2", this.props.form.getFieldsValue());
    };
    isSetDefault = () => {
        this.setState({ isSetDefault: !this.state.isSetDefault });
    };
    openMenu = () => {
        this.setState({
            setBankCard: {
                showBankList: !this.state.setBankCard.showBankList,
            },
        });
    };
    changeBankName = (value, option) => {
        this.props.form.setFieldsValue({ bankname: value });
        this.setState(
            {
                setBankCard: {
                    searchValue: value,
                    showBankList: false,
                    bankAlphabetic: option.props.children[0].props.src,
                },
            },
            () => {
                this.handleFormChange();
            }
        );
        console.log("getFieldValue1", this.props.form.getFieldsValue());
    };
    onclosed = (isAddedNewCardSuccessfully) => {
        this._onclosed = () => {
        this.setState({
            setBankCard: { showBankList: false, searchValue: "" },
            submitButtonDisabled: true,
            isSetDefault: false,
        });
        this.props.closeModal();
        this.props.form.resetFields();
        console.log("onCloseAction");
        }

        if (isAddedNewCardSuccessfully) {
            this._onclosed();
            return;
        }

        this._modal = Modal.confirm({
            className: 'confirm-modal-of-public confirm-modal-of-public-tight hide-ant-modal-close-x-modal',
            icon: null,
            centered: true,
            title: '离开页面？',
            content: <div>您填写的内容将不会被保存。</div>,
            okText: '留下',
            cancelText: '离开',
            onCancel: () => {
                this._onclosed();
            },
            onOk: () => {
                this._modal.destroy();
            }
        });

    };
    render() {
        const { getFieldDecorator } = this.props.form;
        const { BankList, isSetDefault, setBankCard } = this.state;

        return (
            <Modal
                title="添加银行账户"
                visible={this.props.visible}
                onCancel={this.onclosed}
                width={400}
                footer={null}
                maskClosable={false}
                className="modal-pubilc OTP-modal addBankModal"
            >
                <Spin spinning={this.state.isLoading}>
                    {/* <div style={{ textAlign : "center", fontSize : "20px", fontWeight : "800", padding:"15px" }}>添加银行卡</div> */}
                    <Form
                        className="verification-form-wrap"
                        {...formItemLayout}
                        onSubmit={this.handleSubmit}
                        onChange={this.handleFormChange}
                    >
                        <div className="modal-prompt-info" style={{margin:'12px 0', textAlign:'center'}}>提交前请再次确认填写资料正确性，提交后将无法修改。</div>
                        {
                            <Item
                                label="银行名称"
                                className={`Item-bankName ${
                                    setBankCard.showBankList
                                        ? "active"
                                        : "inactive"
                                }`}
                            >
                                {getFieldDecorator("bankname", {
                                    initialValue: setBankCard.searchValue,
                                    rules: [
                                        {
                                            required: true,
                                            message: "请选择银行！",
                                        },
                                    ],
                                })(
                                    <div>
                                        <Input
                                            className={`bankNamewrap ${
                                                setBankCard.searchValue
                                                    ? "have"
                                                    : ""
                                            } ${
                                                setBankCard.showBankList
                                                    ? "active"
                                                    : "inactive"
                                            }`}
                                            size="large"
                                            autoComplete="off"
                                            readOnly={true}
                                            value={setBankCard.searchValue}
                                            placeholder={"选择银行"}
                                            prefix={
                                                setBankCard.searchValue ? (
                                                    <img
                                                        src={`${setBankCard.bankAlphabetic}`}
                                                        style={{
                                                            width: 24,
                                                            height: 24,
                                                            marginRight: 10,
                                                        }}
                                                    />
                                                ) : (
                                                    <span />
                                                )
                                            }
                                            suffix={
                                                !setBankCard.showBankList && (
                                                    <Icon
                                                        type={`${
                                                            !setBankCard.showBankList
                                                                ? "caret-down"
                                                                : "caret-up"
                                                        }`}
                                                        onClick={this.openMenu}
                                                    />
                                                )
                                            }
                                        />
                                        {setBankCard.showBankList && (
                                            <Select
                                                size="large"
                                                loading={
                                                    !BankList.length
                                                        ? true
                                                        : false
                                                }
                                                onChange={this.changeBankName}
                                                open={setBankCard.showBankList}
                                                showArrow={false}
                                                showSearch={true}
                                                optionFilterProp="children"
                                                filterOption={(
                                                    input,
                                                    option
                                                ) => {
                                                    return option.props.value.includes(
                                                        input
                                                    );
                                                }}
                                                notFoundContent={
                                                    <div
                                                        className="notfind"
                                                        style={{
                                                            width: "100%",
                                                            textAlign: "center",
                                                            minHeight: "195px",
                                                        }}
                                                    >
                                                        <div className="line-distance"></div>
                                                        <img
                                                            src="/cn/img/icon/emptyIcon.svg"
                                                            alt="notfind"
                                                            style={{
                                                                width: "80px",
                                                                height: "80px",
                                                            }}
                                                        />
                                                        <p
                                                            style={{
                                                                fontSize: 12,
                                                                color: "#999999",
                                                                lineHeight:
                                                                    "50px",
                                                            }}
                                                        >
                                                            暂无数据
                                                        </p>
                                                    </div>
                                                }
                                                className="bankNameSelect"
                                                dropdownClassName="bankNameSelectDropdown"
                                                dropdownStyle={{
                                                    borderTopLeftRadius: 0,
                                                    borderTopRightRadius: 0,
                                                }}
                                                placeholder={
                                                    <div className="searchwrap">
                                                        <Icon
                                                            type="search"
                                                            style={{
                                                                fontSize: 16,
                                                                marginRight: 6,
                                                            }}
                                                        />
                                                        <span>搜索</span>
                                                    </div>
                                                }
                                            >
                                                {BankList.map((val, index) => {
                                                    let bankname =
                                                        ABankList.find(
                                                            (item) =>
                                                                item.Name ===
                                                                val.name
                                                        );
                                                    return (
                                                        <Option
                                                            key={index}
                                                            value={val.name}
                                                        >
                                                            <img
                                                                style={{
                                                                    width: 24,
                                                                    height: 24,
                                                                    marginRight: 10,
                                                                }}
                                                                src={`/cn/img/bank/${
                                                                    bankname &&
                                                                    bankname.Img
                                                                        ? bankname.Img
                                                                        : "generic"
                                                                }.png`}
                                                            />
                                                            {val.name}
                                                        </Option>
                                                    );
                                                })}
                                            </Select>
                                        )}
                                    </div>
                                )}
                            </Item>
                        }
                        <Item label="账户持有者全名">
                            {getFieldDecorator("username", {
                                rules: [
                                    { required: true, message: "请输入姓名！" },
                                    {
                                        validator: (rule, value, callback) => {
                                            if (
                                                value &&
                                                !realyNameReg.test(value)
                                            ) {
                                                callback("格式不正确");
                                            }
                                            callback();
                                        },
                                    },
                                ],
                            })(
                                <Input
                                    size="large"
                                    maxLength={30}
                                    autoComplete="off"
                                    placeholder="请输入您的全名"
                                />
                            )}
                        </Item>
                        <Item label="银行账户号码">
                            {getFieldDecorator("cardnumber", {
                                rules: [
                                    { required: true, message: "请输入卡号！" },
                                    {
                                        validator: (rule, value, callback) => {
                                            if (
                                                value &&
                                                !_bankNumber.test(value)
                                            ) {
                                                callback("格式不正确");
                                            }
                                            callback();
                                        },
                                    },
                                ],
                            })(
                                <Input
                                    size="large"
                                    maxLength={19}
                                    autoComplete="off"
                                    placeholder="请输入您的账户号码"
                                />
                            )}
                        </Item>
                        <Item label="省/自治区">
                            {getFieldDecorator("province")(
                                <SelectArddress
                                    className="forAddBankCard"
                                    type={""}
                                    datavalue={[]}
                                    disabled={false}
                                    onChange={(val) => {
                                        for (let key in val) {
                                            if (!val[key]) {
                                                this.setState(
                                                    {
                                                        provincesIsValid: false,
                                                    },
                                                    () => {
                                                        this.handleFormChange();
                                                    }
                                                );
                                                return;
                                            }
                                        }

                                        this.setState(
                                            {
                                                provincesIsValid: true,
                                            },
                                            () => {
                                                this.handleFormChange();
                                            }
                                        );
                                    }}
                                />
                            )}
                        </Item>
                        <Item label="城市/城镇">
                            {getFieldDecorator("city", {
                                rules: [
                                    {
                                        required: true,
                                        message: "请输入正确的城市/城镇！",
                                    },
                                    {
                                        validator: (rule, value, callback) => {
                                            if (value && !_city.test(value)) {
                                                callback("格式不正确");
                                            }
                                            callback();
                                        },
                                    },
                                ],
                            })(
                                <Input
                                    size="large"
                                    maxLength={20}
                                    autoComplete="off"
                                    placeholder="请输入城市/城镇"
                                />
                            )}
                        </Item>
                        <Item label="分行">
                            {getFieldDecorator("branch", {
                                rules: [
                                    { required: true, message: "请输入分行！" },
                                    {
                                        validator: (rule, value, callback) => {
                                            if (value && !_branch.test(value)) {
                                                callback("格式不正确");
                                            }
                                            callback();
                                        },
                                    },
                                ],
                            })(
                                <Input
                                    size="large"
                                    maxLength={20}
                                    autoComplete="off"
                                    placeholder="请输入分行"
                                />
                            )}
                        </Item>
                        <Item
                            label=""
                            className="small-form-item defaultCheckbox"
                            style={{ textAlign: "left" }}
                        >
                            {/* {getFieldDecorator("isSetDefault", {
                valuePropName: 'checked'
              })( */}
                            <Checkbox
                                checked={isSetDefault}
                                onChange={this.isSetDefault}
                            >
                                设定为首选银行账户
                            </Checkbox>
                            {/* )} */}
                        </Item>
                        {/* <p className="bottom-sign-2">开户名必须和账号持有者姓名相同，如需修改请联系<Button className="inline" type="link" onClick={global.PopUpLiveChat}>在线客服</Button>。</p> */}
                        <div className="line-distance"></div>
                        <Item {...tailFormItemLayout}>
                            <div className="btn-wrap">
                                <Button
                                    size="large"
                                    type="primary"
                                    htmlType="submit"
                                    block
                                    disabled={this.state.submitButtonDisabled}
                                >
                                    保存
                                </Button>
                            </div>
                        </Item>
                    </Form>
                </Spin>
            </Modal>
        );
    }
}

export default Form.create({ name: "AddBankCard" })(AddBankCard);
